
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Settings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guild"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guild"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guestMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"invite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inviteButtonText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"singleChannel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hideSidebar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"readonly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filesEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCustomAuthEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCaptchaEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"captchaSiteKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"theme"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"css"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"background"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":340}};
    doc.loc.source = {"body":"query Settings($guild: String!) {\n  settings(id: $guild) {\n    guestMode\n    invite\n    inviteButtonText\n    singleChannel\n    hideSidebar\n    readonly\n    filesEnabled\n    isCustomAuthEnabled\n    isCaptchaEnabled\n    captchaSiteKey\n    theme {\n      css\n      colors {\n        primary\n        accent\n        background\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Settings"] = oneQuery(doc, "Settings");
        



//////////////////
// WEBPACK FOOTER
// ./src/app/Settings.graphql
// module id = 1338
// module chunks = 21